/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import AccessRuleGroup from '../model/AccessRuleGroup';
import Error from '../model/Error';

/**
* AccessRules service.
* @module api/AccessRulesApi
* @version 0.0.1
*/
export default class AccessRulesApi {

    /**
    * Constructs a new AccessRulesApi. 
    * @alias module:api/AccessRulesApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the createAccessRule operation.
     * @callback module:api/AccessRulesApi~createAccessRuleCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:model/AccessRuleGroup} accessRuleGroup The new access-rule to create
     * @param {module:api/AccessRulesApi~createAccessRuleCallback} callback The callback function, accepting three arguments: error, data, response
     */
    createAccessRule(accessRuleGroup, callback) {
      let postBody = accessRuleGroup;
      // verify the required parameter 'accessRuleGroup' is set
      if (accessRuleGroup === undefined || accessRuleGroup === null) {
        throw new Error("Missing the required parameter 'accessRuleGroup' when calling createAccessRule");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/access-rules', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteAccessRule operation.
     * @callback module:api/AccessRulesApi~deleteAccessRuleCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:model/AccessRuleGroup} accessRuleGroup The access-rule to delete
     * @param {module:api/AccessRulesApi~deleteAccessRuleCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteAccessRule(accessRuleGroup, callback) {
      let postBody = accessRuleGroup;
      // verify the required parameter 'accessRuleGroup' is set
      if (accessRuleGroup === undefined || accessRuleGroup === null) {
        throw new Error("Missing the required parameter 'accessRuleGroup' when calling deleteAccessRule");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/access-rules', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getAccessRules operation.
     * @callback module:api/AccessRulesApi~getAccessRulesCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/AccessRuleGroup>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/AccessRulesApi~getAccessRulesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/AccessRuleGroup>}
     */
    getAccessRules(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [AccessRuleGroup];
      return this.apiClient.callApi(
        '/access-rules', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateAccessRule operation.
     * @callback module:api/AccessRulesApi~updateAccessRuleCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:model/AccessRuleGroup} accessRuleGroup The new access-rule information
     * @param {module:api/AccessRulesApi~updateAccessRuleCallback} callback The callback function, accepting three arguments: error, data, response
     */
    updateAccessRule(accessRuleGroup, callback) {
      let postBody = accessRuleGroup;
      // verify the required parameter 'accessRuleGroup' is set
      if (accessRuleGroup === undefined || accessRuleGroup === null) {
        throw new Error("Missing the required parameter 'accessRuleGroup' when calling updateAccessRule");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/access-rules', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
